// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.scribe.CreateEncounterScribeSessionFieldValueRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateEncounterScribeSessionFieldValueRequest extends GandalfModelBase {

	@GandalfLabel('Field')
	@GandalfValidator({ notNull: { message: 'Field is required' } })
	@GandalfValidator({ sizeString: { message: 'Field must be between 1 and 50 characters', minLength: 1, maxLength: 50 } })
	@GandalfProperty({ designType: String, isRequired: true })
	fieldName!: string;

	@GandalfLabel('Field Value')
	@GandalfValidator({ notNull: { message: 'Field Value is required' } })
	@GandalfValidator({ sizeString: { message: 'Field Value must be between 1 and 4000 characters', minLength: 1, maxLength: 4000 } })
	@GandalfProperty({ designType: String, isRequired: true })
	fieldValue!: string;

	@GandalfLabel('Test')
	@GandalfValidator({ notNull: { message: 'Test is required' } })
	@GandalfValidator({ sizeString: { message: 'Test must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	testName!: string;

}
